import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NewSnackbar from 'components/organisms/Snackbar/Snackbar';
import { clearSnackbar } from 'modules/snackbar';

const SuccessSnackbar = () => {
  const dispatch = useDispatch();

  const { successSnackbarMessage, successSnackbarOpen, successSnackbarOption } =
    useSelector((state) => state.snackbar);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(clearSnackbar());
  };

  return typeof successSnackbarMessage !== 'undefined' ? (
    <NewSnackbar
      open={successSnackbarOpen}
      option={successSnackbarOption}
      message={successSnackbarMessage}
      onClose={handleClose}
    />
  ) : null;
};

export default SuccessSnackbar;
